import { useSelector } from "react-redux"
import { useCallback, useMemo } from "react"

export const useGroups = () => {
	const { groups } = useSelector((state) => state.navInfo.login)

	const isBoss = useMemo(() => {
		return groups.includes("boss")
	}, [groups])

	const isAdmin = useMemo(() => {
		return groups.includes("admin")
	}, [groups])

	const isResponsableAtelier = useMemo(() => {
		return groups.includes("responsable_atelier")
	}, [groups])

	const isResponsableDepannage = useMemo(() => {
		return groups.includes("responsable_depannage")
	}, [groups])

	const isAdminAtelier = useMemo(() => {
		return groups.includes("admin_atelier")
	}, [groups])

	const isAdminDepannage = useMemo(() => {
		return groups.includes("admin_depannage")
	}, [groups])

	const isAssistantAdmin = useMemo(() => {
		return groups.includes("assistant_admin")
	}, [groups])

	const isEmploye = useMemo(() => {
		return groups.includes("employe")
	}, [groups])

	// Catégories de notifications reçues par le user : RÉSOLUES PAR LE SERVEUR
	// (l'éligibilité est éditable dans Configuration → Notifications, elle ne se
	// déduit plus des groupes côté front). La cloche s'affiche si ≥ 1 catégorie.
	const notifCategories = useSelector(
		(state) => state.accessInfo.notifCategories,
	)

	// Test générique d'appartenance : `hasGroup("admin")` ou
	// `hasGroup(["admin", "responsable_atelier"])` (au moins un). Le groupe boss
	// contourne le gating (propriétaire / super-admin) — cohérent avec le backend.
	const hasGroup = useCallback(
		(needed) => {
			if (needed === null || needed === undefined) return true
			if (groups.includes("boss")) return true
			const list = Array.isArray(needed) ? needed : [needed]
			if (list.length === 0) return true
			return list.some((g) => groups.includes(g))
		},
		[groups],
	)

	return {
		groups,
		hasGroup,
		isBoss,
		isAdmin,
		isResponsableAtelier,
		isResponsableDepannage,
		isAdminAtelier,
		isAdminDepannage,
		isAssistantAdmin,
		isEmploye,
		notifCategories,
	}
}
